/**
 * Enum of keys used by the Pinia persistence module (stored in local storage).
 */
export enum LocalStorageKey {
  Navigation = 'navigation'
}
